/** What each permission module is called on screen; nav labels where the module has a page. */
export const SCREEN_NAMES = {
    account: 'Accounts',
    accountingIntegration: 'Sage Intacct',
    accountOnboarding: 'Account Onboarding',
    accountsPayable: 'Accounts Payable',
    accountsReceivable: 'Accounts Receivable',
    auditLog: 'Audit Trail',
    biReport: 'BI Reports',
    bom: 'Bill of Materials',
    brand: 'Brands',
    calendar: 'Calendar',
    cannabisCompliance: 'Cannabis Compliance',
    carrier: 'Carriers',
    class: 'Classes',
    commission: 'Commissions',
    company: 'Company Setup',
    contact: 'Contacts',
    currency: 'Currencies',
    customer: 'Customers',
    customField: 'Custom Fields',
    data: 'Data',
    deliveryLogistics: 'Delivery Logistics',
    department: 'Departments',
    dimeCheckout: 'Checkout',
    event: 'Events',
    eventStaffing: 'Event Staffing',
    expense: 'Expenses',
    importsExport: 'Imports & Exports',
    integrations: 'Integrations',
    inventory: 'Inventory',
    invoice: 'Invoices',
    leafLinkIntegration: 'LeafLink',
    location: 'Locations',
    locationGroup: 'Warehouses',
    manufactureOrder: 'Manufacturing',
    media: 'Media',
    menu: 'Menus',
    monitor: 'Monitor',
    part: 'Parts',
    payment: 'Payments',
    paymentGateway: 'Payment Gateways',
    paymentTerms: 'Payment Terms',
    picking: 'Picking',
    pricingEngine: 'Pricing',
    pricingRule: 'Pricing Rules',
    product: 'Products',
    project: 'Projects',
    promotion: 'Credits',
    purchaseOrder: 'Purchase Orders',
    qrCode: 'QR Codes',
    receiving: 'Receiving',
    reports: 'Custom Reports',
    rma: 'Supplier Returns',
    salesOrder: 'Sales Orders',
    salesTarget: 'Sales Targets',
    schedule: 'Schedules',
    settings: 'Company Settings',
    shipping: 'Shipping',
    strain: 'Strains',
    task: 'Tasks',
    taxRate: 'Tax Rates',
    territory: 'Territories',
    transferOrder: 'Transfer Orders',
    uom: 'Units of Measure',
    user: 'Users',
    userGroup: 'Roles',
    vendor: 'Vendors',
    workOrder: 'Work Orders',
};
//# sourceMappingURL=screen-names.js.map